// extracted by mini-css-extract-plugin
module.exports = {"img__box__wrapper":"ImageBox_img__box__wrapper__3ITb5","img__wrapper":"ImageBox_img__wrapper__1dzBo","overlay":"ImageBox_overlay__bQHWV"};